import * as React from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import { FormControl, InputLabel, FormHelperText } from "@mui/material";
import Renderers from '~common/lib/renderers';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: 15,
      display: "flex",
      width: "100%",
    },
    chip: {
      display: "flex",
      border: "solid 1px #bbb",
      borderRadius: 10,
      margin: "5px 5px 5px 0px",
    },
    key: {
      display: "flex",
      backgroundColor: "#b5fdd8",
      borderRadius: "10px 0px 0px 10px",
      borderRight: "solid 1px #bbb",
      padding: "5px 5px 5px 10px",
    },
    criticalKey: {
      display: "flex",
      backgroundColor: "#fbeb9e",
      borderRadius: "10px 0px 0px 10px",
      borderRight: "solid 1px #bbb",
      padding: "5px 5px 5px 10px",
    },
    userKey: {
      display: "flex",
      backgroundColor: "#b5d2fd",
      borderRadius: "10px 0px 0px 10px",
      borderRight: "solid 1px #bbb",
      padding: "5px 5px 5px 10px",
    },
    value: {
      display: "flex",
      backgroundColor: "#fafafa",
      borderRadius: "0px 10px 10px 0px",
      padding: "5px 10px 5px 5px",
    },
  })
);

interface JSONLabelProps {
  history: any;
  data: any;
  path: any;
  value: any;
  fieldDefinition: any;
}

export function registerJsonLabel() {
  console.log("Registering JsonLabel")
  if(!Renderers.find("JsonLabel")){
    console.log("Registering JsonLabel")
    Renderers.register("JsonLabel", JSONLabel)
  }
}

// export const ApManagement: React.FC<ApManagementProps> = ({history, match}) => {
export const JSONLabel: React.FC<JSONLabelProps> = ({
  history,
  data,
  path,
  value,
  fieldDefinition
}) => {
  const classes = useStyles();

  // Return empty if there are no objects
  if (!value) {
    return null;
  }

  var chips:Array<any> = [];
  for (const [key, val] of Object.entries(value)) {
    let keyClass = classes.key;
    switch (key) {
      case "templateType":
        keyClass = classes.criticalKey;
      case "formType":
        keyClass = classes.criticalKey;
      case "userType":
        keyClass = classes.userKey;
    }

    chips.push (
        <div name={`JsonAttribute${chips.length+1}`} key={key} className={classes.chip}>
          <div className={keyClass}>{key}</div>
          <div className={classes.value}>{val}</div>
        </div>
      );
  }

  return (
    <FormControl name={fieldDefinition.key} className={classes.formDefField}>
      <InputLabel shrink>{fieldDefinition.title}</InputLabel>
      <div className={classes.container}>{chips}</div>
    </FormControl>
  );
};

export default JSONLabel;
